import Contact from '@/models/contact';
import BaseService from './base.service';

class ContactService extends BaseService<Contact> {}
export const contactService = new ContactService("/contact");
 